import MainLayout, { MainLayoutProps } from "../Main";

const NewReportLayout: React.FC<MainLayoutProps> = (props: MainLayoutProps) => (
  <MainLayout {...props} hideSidebar={true} hideSubHeader={true}></MainLayout>
);
export default NewReportLayout;
